<div class="queue-view-container">
  <div class="queue-view-panel-heading-tabs">
    <ng-container *ngFor="let tab of tabs">
      <div class="tab-separator" *ngIf="isLiveWorkloadTabActive(tab.id)"></div>
      <h4 class="panel-title panel-title-button"
          [ngClass]="{'active': currentTab === tab}"
          (click)="changeTab(tab)"
          attr.data-automation-id="bc-queue-view-{{ tab.name }}">
        {{ tab.name | translate }}
      </h4>
    </ng-container>
    <div class="panel-title spacer">
      <div class="dropdown-container" *ngIf="isDepartmentSelectorVisible">
        <mat-form-field [floatLabel]="'never'" [color]="'accent'">
          <mat-select [ngModel]="selectedDepartments" (openedChange)="onOpenedStateChange($event)" (selectionChange)="onSelectionChange($event)" id="dropdown-selector" multiple>
            <mat-select-trigger>
              <div class="department-trigger-container">
                <ng-container [ngSwitch]="selectedDepartments.length">
                  <span *ngSwitchCase="departmentList.length">{{'queueView.departmentDropdown.allDepartments' | translate}}</span>
                  <span *ngSwitchCase="2" title="{{selectedDepartments[0].name}}, {{selectedDepartments[1].name}}">
                    {{selectedDepartments[0].name}}, {{selectedDepartments[1].name}}
                  </span>
                  <span *ngSwitchCase="1" title="{{selectedDepartments[0].name}}">{{selectedDepartments[0].name}}</span>
                  <span *ngSwitchCase="0">{{'queueView.departmentDropdown.departmentsPlaceholder' | translate}}</span>
                  <span *ngSwitchDefault title="{{selectedDepartments[0].name}}(+{{selectedDepartments.length - 1}})">
                    {{selectedDepartments[0].name}}(+{{selectedDepartments.length - 1}})
                  </span>
                </ng-container>
                <svg-icon icon="department-alt" class="department-dropdown-icon"></svg-icon>
              </div>
            </mat-select-trigger>
            <mat-checkbox [checked]="selectedDepartments.length === departmentList.length"
                          [indeterminate]="selectedDepartments.length && selectedDepartments.length < departmentList.length"
                          [disableRipple]="true"
                          class="toggle-all-button"
                          (change)="toggleAllDepartments()">
              {{'queueView.departmentDropdown.allDepartments' | translate}}
            </mat-checkbox>
            <mat-option *ngFor="let department of departmentList" [value]="department">{{department.name}}</mat-option>
          </mat-select>
          <mat-label>
            <span>{{'queueView.departmentDropdown.departmentsPlaceholder' | translate}}</span>
            <svg-icon icon="department-alt" class="department-dropdown-icon"></svg-icon>
          </mat-label>
        </mat-form-field>
      </div>
      <div class="tab-separator"></div>
      <div class="open-button"
           (click)="navigateToWorkspace()"
           [attr.data-automation-id]="'bc-back-to-workspace'">
        <workitem-activity-indicator [optionalClassName]="'qv-indicator'"
                                     [unansweredMessageCount]="getUnansweredMessageCount()">
        </workitem-activity-indicator>
        <svg-icon icon="arrow-left"></svg-icon>
      </div>
    </div>
  </div>

  <app-loading *ngIf="areDepartmentsLoading" class="queue-view-tab-container"></app-loading>
  <app-queue-view-tab *ngIf="currentTab && !areDepartmentsLoading && !isLiveWorkloadTabActive(currentTab?.id)" [tabId]="currentTab?.id" [selectedDepartments]="selectedDepartments" class="queue-view-tab-container"></app-queue-view-tab>
  <app-live-workload-tab
    *ngIf="currentTab && !areDepartmentsLoading && isLiveWorkloadTabActive(currentTab?.id)"
    [selectedDepartments]="selectedDepartments"
    (navigateToOtherTab)="onNavigate($event)"
    (filterDepartments)="onFilterDepartments($event)"
    class="queue-view-tab-container"
  ></app-live-workload-tab>
</div>
